import Vue from 'vue'
import Router from 'vue-router'
// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')
const CleanContainer = () => import('@/containers/CleanContainer')

const CodelabsList = () => import('@/views/Codelabs/List')
const CodelabsCreate = () => import('@/views/Codelabs/Create')
const CodelabsDetails = () => import('@/views/Codelabs/Details')

const CategoriesCreate = () => import('@/views/Categories/Create')

const IamPermissionMain = () => import('@/views/Iam/Permission/Index')
const IamPermissionList = () => import('@/views/Iam/Permission/List')
const IamPermissionCreate = () => import('@/views/Iam/Permission/Create')
const IamPermissionDetails = () => import('@/views/Iam/Permission/Details')

const IamProjectsMain = () => import('@/views/Iam/Projects/Index')
const IamProjectsList = () => import('@/views/Iam/Projects/List')
const IamProjectsCreate = () => import('@/views/Iam/Projects/Create')
const IamProjectsDetails = () => import('@/views/Iam/Projects/Details')

const Login = () => import('@/views/Auth/Login')
const Register = () => import('@/views/Auth/Register')
const ForgotPassword = () => import('@/views/Auth/ForgotPassword')
const ResetPassword = () => import('@/views/Auth/ResetPassword')
const ConfirmEmail = () => import('@/views/Auth/ConfirmEmail')
const CodelabsAuth = () => import('@/views/Auth/Codelabs')

Vue.use(Router)

export default new Router({
    mode: 'hash',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/',
            redirect: '/codelabs',
        },
        {
            path: '/auth',
            name: 'Auth',
            component: CleanContainer,
            children: [
                {
                    path: 'login',
                    name: 'Login',
                    component: Login,
                },
                {
                    path: 'forgot-password',
                    name: 'ForgotPassword',
                    component: ForgotPassword,
                },
                {
                    path: 'reset-password',
                    name: 'ResetPassword',
                    component: ResetPassword,
                },
                {
                    path: 'register',
                    name: 'Register',
                    component: Register,
                },
                {
                    path: 'confirmEmail/:id',
                    name: 'Confirm Email',
                    component: ConfirmEmail,
                },
                {
                    path: 'codelab/:id',
                    name: 'Codelab',
                    component: CodelabsAuth,
                },
            ],
        },
        {
            path: '/codelabs',
            redirect: '/codelabs',
            name: 'Codelabs',
            component: DefaultContainer,
            meta: { auth: true },
            children: [
                {
                    path: '/',
                    name: 'List',
                    component: CodelabsList,
                },
                {
                    path: 'create',
                    name: 'Create',
                    component: CodelabsCreate,
                },
                {
                    path: 'categories/create',
                    name: 'Create',
                    component: CategoriesCreate,
                },
                {
                    path: ':id',
                    name: 'Details',
                    component: CodelabsDetails,
                },
            ],
        },
        {
            path: '/iam',
            redirect: '/iam/permission/list',
            name: 'Iam',
            component: DefaultContainer,
            meta: { auth: true },
            children: [
                {
                    path: 'permission',
                    redirect: '/iam/permission/list',
                    name: 'Permission',
                    component: IamPermissionMain,
                    children: [
                        {
                            path: 'list',
                            name: 'List',
                            component: IamPermissionList,
                        },
                        {
                            path: 'create',
                            name: 'Create',
                            component: IamPermissionCreate,
                        },
                        {
                            path: ':id',
                            name: 'Details',
                            component: IamPermissionDetails,
                        },
                    ],
                },
                {
                    path: 'projects',
                    redirect: '/iam/projects/list',
                    name: 'Projects',
                    component: IamProjectsMain,
                    children: [
                        {
                            path: 'list',
                            name: 'List',
                            component: IamProjectsList,
                        },
                        {
                            path: 'create',
                            name: 'Create',
                            component: IamProjectsCreate,
                        },
                        {
                            path: ':id',
                            name: 'Details',
                            component: IamProjectsDetails,
                        },
                    ],
                },
            ],
        },
    ],
})
